module.exports = __webpack_public_path__ + "media/images/sms-7c254c7a8675923a2969c6d31c292245.svg";